module.exports = __webpack_public_path__ + "img/catehism-1780-pagina-de-titlu-big.b4499323.jpg";